import type { MessageDescriptor } from 'react-intl-next';

import { aiAutocompleteMessages } from '@atlaskit/editor-common/ai-messages';
import type { PMPluginFactoryParams } from '@atlaskit/editor-common/types';

/**
 * Parses the formatted trigger-keywords string (comma-separated phrases) into trimmed tokens.
 */
function splitAutocompleteTriggerKeywords(
	intl: PMPluginFactoryParams['getIntl'],
	messages: MessageDescriptor,
): readonly string[] {
	return intl()
		.formatMessage(messages)
		.split(',')
		.map((s) => s.trim())
		.filter((s) => s.length > 0);
}

export function getSummaryKeywords(intl: PMPluginFactoryParams['getIntl']): readonly string[] {
	return splitAutocompleteTriggerKeywords(intl, aiAutocompleteMessages.summaryKeywords);
}

export function getConclusionKeywords(intl: PMPluginFactoryParams['getIntl']): readonly string[] {
	return splitAutocompleteTriggerKeywords(intl, aiAutocompleteMessages.conclusionKeywords);
}

export function getNextStepsKeywords(intl: PMPluginFactoryParams['getIntl']): readonly string[] {
	return splitAutocompleteTriggerKeywords(intl, aiAutocompleteMessages.nextStepsKeywords);
}
